module.exports = __webpack_public_path__ + "img/measurement_info_back_hand_left.8252addd.jpg";